import MockAdapter from 'axios-mock-adapter'

import {sleepResponse} from '../mockServices/utils'
import {mockStore} from '../mockStore'

export const enableHProduceFeatureFlagsEndpoints = (mock: MockAdapter) => {
  // ----- hproduce-feature-flags endpoints -----

  // GET 'hproduce-common' feature flags
  mock.onGet(new RegExp('hproduce-feature-flags/hproduce-common/feature-flags$')).reply(() => {
    const scenario = mockStore.scenario()
    const {
      burglengenfeld: {featureFlags}
    } = scenario
    return sleepResponse([200, featureFlags])
  })
}
